(function () {
  'use strict';

  // En-tête : bordure au défilement
  var header = document.querySelector('.lm-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Menu mobile
  var burger = document.querySelector('.lm-burger');
  var drawer = document.getElementById('lm-drawer');
  if (burger && drawer) {
    var close = function (refocus) {
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Ouvrir le menu');
      if (refocus) burger.focus();
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lm-locked');
    };
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') !== 'true';
      burger.setAttribute('aria-expanded', String(open));
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('lm-locked', open);
      burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      if (open) { var first = drawer.querySelector('a'); if (first) setTimeout(function () { first.focus(); }, 60); }
    });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1024) close(); });
  }

  // Bandeau défilant : duplique le contenu pour une boucle continue
  document.querySelectorAll('.lm-marquee__track').forEach(function (track) {
    if (track.dataset.cloned) return;
    track.innerHTML += track.innerHTML;
    track.dataset.cloned = '1';
  });

  // Apparition au défilement
  var items = document.querySelectorAll('.lm-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Formulaire : préremplit le forfait depuis ?forfait=… et ouvre le mode RDV depuis #rdv
  var form = document.querySelector('.lm-form');
  if (form) {
    var params = new URLSearchParams(window.location.search);
    var plan = params.get('forfait');
    if (plan) {
      var sel = form.querySelector('select[name="contact[Forfait]"]');
      if (sel) {
        Array.prototype.forEach.call(sel.options, function (o) {
          if (o.value.toLowerCase().indexOf(plan.toLowerCase()) === 0) sel.value = o.value;
        });
      }
      var devis = form.querySelector('input[value="Demande de devis"]');
      if (devis) devis.checked = true;
    }
    if (window.location.hash === '#rdv' || params.get('rdv')) {
      var rdv = form.querySelector('input[value="Appel découverte"]');
      if (rdv) rdv.checked = true;
    }
  }

  // « Gérer les cookies » : rouvre les préférences du bandeau Shopify ; sinon, suit le lien vers la politique
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-lm-cookies]');
    if (!link) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      e.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });

  // Réinitialise les sections dans l'éditeur de thème
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.lm-reveal').forEach(function (el) { el.classList.add('is-in'); });
    e.target.querySelectorAll('.lm-marquee__track').forEach(function (track) {
      if (!track.dataset.cloned) { track.innerHTML += track.innerHTML; track.dataset.cloned = '1'; }
    });
  });
})();
